class WIproductgallery extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.clickSelect();   
    }

    // Hover select

    // Click Select
    clickSelect() {
        let thumbImages = this.querySelectorAll('.WI_mainProductGallery_thumbImg');
        thumbImages.forEach(img => {
            img.addEventListener('click', () => {
                thumbImages.forEach(sibling => {
                    sibling.style.opacity = 0.5;
                    sibling.style.outline = "none";
                });
                img.style.opacity = 1;
                img.style.outline = "1px solid #000";
                let thumbId = img.getAttribute('data-imgID');
                this.scrollToImage(thumbId);
            });
        });
    }

    // Scroll to image
    scrollToImage(id) {
        if (!id) return;
    
        let scrollDiv = this.querySelector('.WI_mainProductGallery_in');
        let imgToScroll = this.querySelector(`#${id}`);
    
        if (scrollDiv && imgToScroll) {
            let targetScroll = imgToScroll.offsetTop - scrollDiv.offsetTop;
            let startScroll = scrollDiv.scrollTop;
            let distance = targetScroll - startScroll;
            let duration = 500; // Adjust for smoothness
            let startTime = null;
    
            // Ease-in-out function
            function easeInOutQuad(t) {
                return 1 - (1 - t) * (1 - t);
            }
    
            function smoothScroll(timestamp) {
                if (!startTime) startTime = timestamp;
                let timeElapsed = timestamp - startTime;
                let progress = Math.min(timeElapsed / duration, 1);
    
                // Apply ease-in-out function
                let easedProgress = easeInOutQuad(progress);
    
                scrollDiv.scrollTop = startScroll + (distance * easedProgress);
    
                if (progress < 1) {
                    requestAnimationFrame(smoothScroll);
                }
            }
    
            requestAnimationFrame(smoothScroll);
        }
    }
    
}

customElements.define('wi-product-gallery', WIproductgallery);

// load images in fading animation
let cardImages = document.querySelectorAll('.WI_mobileProductGalleryAni');
cardImages.forEach(img => {
    if (img.complete) {
        setTimeout(() => {
            img.classList.add('WI_productGalImage_load');
        }, 500);
        console.log("loaded (already complete)");
    } else {
        img.addEventListener('load', () => {
            setTimeout(() => {
                img.classList.add('WI_productGalImage_load');
            }, 500);
          console.log("loaded (on load event)");
        });
    }
});